import { useEffect, useState } from "react"
import HeaderTarifs from "./HeaderTarifs"
import RatePlanGrid from "./RatePlanGrid/RatePlanGrid"
import RatePlansDrawer from "./RatePlansDrawer"
import axios from "axios"
import { useParams } from "react-router-dom"
import { Stack, Container } from "@mantine/core";

const TarifsPage = () => {
  const hotelParams = useParams();
  const hotelId = hotelParams.hotelId;

  const [rooms, setRooms] = useState([])
  const [ratePlans, setRatePlans] = useState([])
  const [showDrawer, setShowDrawer] = useState(false)
  const [editingRatePlan, setEditingRatePlan] = useState(null)

  useEffect(() => {

    const fetchRooms = async () => {

      try {

        const res = await axios.get(`https://api.komorotel.com/api/hotels/rooms/${hotelId}`)

        setRooms(res.data)

      } catch (err) {

        console.error(err)

      }

    }

    fetchRooms()

  }, [])
   useEffect(() => {

    const fetchRatePlan = async () => {

      try {

        const res = await axios.get(`https://api.komorotel.com/api/tarifs/rateplans/${hotelId}`)

        setRatePlans(res.data)

      } catch (err) {

        console.error(err)

      }

    }

    fetchRatePlan()

  }, [])

  const openDrawer = () => {
    setShowDrawer(true)
  }

  const closeDrawer = () => {
    setShowDrawer(false)
    setEditingRatePlan(null)


  }



const handleCreateRatePlan = async (newRatePlan) => {

  try {

    const res = await axios.post(
      "https://api.komorotel.com/api/tarifs/rateplans",
      newRatePlan,
      {withCredentials: true}
    )

    setRatePlans((prev) => [
      ...prev,
      res.data
    ])

  } catch (err) {

    console.error(err)

  }

}
const handleDeleteRatePlan = async (ratePlan) => {

  try {

    await axios.delete(
      `https://api.komorotel.com/api/tarifs/rateplans/${ratePlan._id}`,
      { withCredentials: true }
    )

    setRatePlans((prev) =>
      prev.filter((rp) => rp._id !== ratePlan._id)
    )

  } catch (err) {

    console.error(err)

  }

}

const handleUpdateRatePlan = async (ratePlanId, newRatePlan) => {

  try {

    const res = await axios.put(
      `https://api.komorotel.com/api/tarifs/rateplans/${ratePlanId}`,
      newRatePlan,
      { withCredentials: true }
    )

    setRatePlans((prev) =>
      prev.map((plan) =>
        plan._id.toString() === ratePlanId.toString()
          ? res.data
          : plan
      )
    )

  } catch (err) {

    console.error(err)

  }

}
const handleEdit = (plan) => {

  setEditingRatePlan(plan)

  setShowDrawer(true)

}


  return (

    <Container size="lg" py="xl">

  <Stack gap="xl">

    <HeaderTarifs openDrawer={openDrawer}/>

    <RatePlanGrid
      ratePlans={ratePlans}
      handleEdit={handleEdit}
      handleDelete={handleDeleteRatePlan}
    />

  </Stack>

  <RatePlansDrawer
    show={showDrawer}
    onHide={closeDrawer}
    rooms={rooms}
    onCreate={handleCreateRatePlan}
    onUpdate={handleUpdateRatePlan}
    hotelId={hotelId}
    editingPlan={editingRatePlan}
  />

</Container>

  )
}

export default TarifsPage